import React from 'react'
import Annotations from './Annotations'
import AdAnnotationOverlay from './AdAnnotationOverlay'

class AdAnnotations extends Annotations {
  static init() {
    if (!this.instance) {
      this.instance = new AdAnnotations();
    }
    return this.instance;
  }

  static unload() {
    this.instance = null;
  }

  constructor() {
    super();
    this.name = "AdAnnotations"
  }

  syncCurrentPageFromUrl() {
    // no-op, ad annotations don't have page numbers.
  }

  popupComponent(annotation, number, id) {
    return <AdAnnotationOverlay klass={this} id={id} annotation={annotation} number={number} annotationTypes={this.annotationTypes} roleType={this.roleType} readOnly={this.readOnly} />
  }
}

export default AdAnnotations
